import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-loop-left', 'ArrowLoopLeft', [["path",{"d":"M13 21v-13a4 4 0 1 1 4 4h-13"}],["path",{"d":"M8 16l-4 -4l4 -4"}]]);